import Icon from '../components/Icon.vue'

Icon.register({
  mobile: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M272 0c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48h-224c-26.5 0-48-21.5-48-48v-416c0-26.5 21.5-48 48-48h224zM160 480c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mobile.js
// module id = 1574
// module chunks = 0